export var CookieNames;
(function (CookieNames) {
    CookieNames["OIDC_COOKIE"] = "lll_oidc_token";
    CookieNames["LLL_REFRESH_TOKEN"] = "lll_refresh_token";
    CookieNames["LLL_REF_PART"] = "lll-ref-part";
    CookieNames["LLL_REF_FULL"] = "lll-ref-full";
})(CookieNames || (CookieNames = {}));
